export enum PopupTypes {
    LOGIN_SIGNUP = "LogIn-SignUp",
    DELETE = "Delete",
    TEXT_EDITOR = "TextEditor",
    PAYMENT_TEXTEDITOR = "PaymentReceiptTextEditor",
    INVOICE_PREVIEW = "PaymentReceiptPreview",
    EMAIL_EDITOR = "SettingsNotificationsTextEditor",
    HTML_EDITOR = "HTMLEditor",
    DELETE_RULE = "DeleteRule",
    FONTS = "Fonts",
    SHARE = "Share",

    EMPTY_FORM = "EmptyFormPerview",
}

export enum LoginPopupState {
    LOGIN = "LOGIN",
    SIGNUP = "SIGNUP",
    FORGOT_PASSWORD = "FORGOT_PASSWORD",
}
